import { useMemo, useState, type ReactNode, type JSX } from 'react';

import { type AuthUser } from '@/schemas/auth-user';

import { UserContext } from './userContext';

export function UserProvider({ children }: { children: ReactNode }): JSX.Element {
  const [user, setUserState] = useState<AuthUser | null>(null);

  const setUser = (data: AuthUser): void => {
    setUserState(data);
  };

  const clearUser = (): void => {
    setUserState(null);
  };

  const contextValue = useMemo(() => ({ user, setUser, clearUser }), [user]);

  return <UserContext value={contextValue}>{children}</UserContext>;
}
